import waveform from '../elements/waveform.js';
waveform.register();
